module.exports = __webpack_public_path__ + "img/246.1c543b6c.jpg";